<form name="FrmSupplierContactRow" #supplierContactRowForm="ngForm" autocomplete="nope">
    <div class="d-flex flex-wrap align-items-start" *ngIf="supplierContact.Contact">
        <div class="mx-1 mb-1 d-flex flex-column align-items-start" style="width:150px;">
                <paf-combobox *ngIf="supplierContact.Contact.Civility" style="width: 100%;" id="Civility"
                    name="civility" 
                    [bindToId]="true"
                    [disabled]="isInputControlDisabled" 
                    [(ngModel)]="supplierContact.Contact.Civility.Id" 
                    [required]="isRequired()"
                    [headerPafLabel]="noHeader ? '' : 'Civilite'"
                    [data]="sharedDataSvc.civilities">
                </paf-combobox>
                        <validation-errors [form]="supplierContactRowForm" controlName="civility"></validation-errors>
           
        </div>
        <div class="mx-1 mb-1 d-flex flex-column align-items-start" style="width:200px;">
            <label *ngIf="!noHeader" class="control-label" paflabel="Prenom"></label>
            <input type="text" class="form-control" id="Firstname" name="Firstname" [(ngModel)]="contact.Firstname" upperCase
                [disabled]="isInputControlDisabled"  [required]="isRequired()"  autocomplete="nope" />
                <validation-errors [form]="supplierContactRowForm" controlName="Firstname"></validation-errors>
        </div>
        <div class="mx-1 mb-1 d-flex flex-column align-items-start" style="width:200px">
            <label *ngIf="!noHeader" class="control-label" paflabel="Nom"></label>
            <input type="text" class="form-control" id="Lastname" name="Lastname" [(ngModel)]="contact.Lastname" upperCase
                [disabled]="isInputControlDisabled"  [required]="isRequired()" autocomplete="nope" />
                <validation-errors [form]="supplierContactRowForm" controlName="Lastname"></validation-errors>
        </div>
        <div class="mx-1 mb-1 d-flex flex-column align-items-start" style="width:200px">
            <label *ngIf="!noHeader" class="control-label" paflabel="Fonction"></label>
                <textarea textareaAutoresize  class="form-control singlerow" id="Fonction" name="Fonction" [(ngModel)]="contact.Fonction" rows="1"
                    [disabled]="isInputControlDisabled"  autocomplete="nope">
                </textarea>
        </div>
        <div class="mx-1 mb-1 d-flex flex-column align-items-start" style="width:100px">
            <label *ngIf="!noHeader" class="control-label" paflabel="Telephone"></label>
            <input type="text" class="form-control" id="Phone" name="Phone" [(ngModel)]="contact.Phone" 
                [disabled]="isInputControlDisabled"
                [required]="isRequired()" autocomplete="nope" />
            <validation-errors [form]="supplierContactRowForm" controlName="Phone"></validation-errors>
        </div>
        <div class="mx-1 mb-1 d-flex flex-column align-items-start" style="width:100px">
            <label *ngIf="!noHeader" class="control-label" paflabel="Mobile"></label>
            <input type="text" class="form-control" id="CellPhone" name="CellPhone" [(ngModel)]="contact.CellPhone"
                [disabled]="isInputControlDisabled" autocomplete="nope" />
        </div>
        <div class="mx-1 mb-1 d-flex flex-column align-items-start" style="width:180px">
                    <label *ngIf="!noHeader" class="control-label" paflabel="Email"></label>
                    <input type="email" email="true" [required]="isRequired()" class="form-control" id="Email" name="Email" [(ngModel)]="contact.Email" [emailUnique]="contact.Id"
                    [disabled]="isInputControlDisabled || !(addButton || isEditing)" autocomplete="nope" />
                    <validation-errors [form]="supplierContactRowForm" controlName="Email"></validation-errors>
        </div>
        <div class="mx-1 mb-1" style="width:100px">
            <switchery-ios class="mt-1" *ngIf="(updateButton || addButton) && !isReferent"  [label]="TopCreateAccountLabel | async" [(ngModel)]="TopCreateAccount" size="small" name="TopCreateAccount" [disabled]="isInputControlDisabled || isEmptyReferent || TopCreateAccountDisabled">
            </switchery-ios>
        </div>

        <div class="flex-grow-1 d-flex align-items-center justify-content-end mb-1">
            <div *ngIf="!disabled" class="btn-group-xs">
                <button *ngIf="!disabled && updateButton && !editActivated" class="btn btn-xs btn-warning" btnDebounceClick paftooltip="Modifier_le_contact"
                    (debounceClick)="edit()"><i class="fas fa-user-edit"></i></button>
                <button *ngIf="updateButton && editActivated" class="btn btn-xs btn-default" btnDebounceClick (debounceClick)="undo()"  paftooltip="Annuler_les_modifications_du_contact">
                    <i class="fas fa-undo"></i></button>
                <button *ngIf="updateButton && editActivated" class="btn btn-xs btn-primary" [disabled]="supplierContactRowForm.invalid" btnDebounceClick paftooltip="Valider_les_modifications_du_contact"
                    (debounceClick)="update()"><i class="fas fa-user-check"></i></button>
                <button *ngIf="delButton && !editActivated" class="btn btn-xs btn-danger ml-1" (debounceClick)="delete()" btnDebounceClick paftooltip="Supprimer_le_contact">
                    <i class="fas fa-trash-alt"></i></button>
                <button *ngIf="addButton" class="btn btn-xs btn-success" (debounceClick)="add()" [disabled]="btnAddDisabled" btnDebounceClick paftooltip="Ajouter_un_contact">
                    <i class="fas fa-plus-square"></i></button>
                <button *ngIf="addButton && avecSaisie" class="btn btn-xs btn-secondary ml-1" (debounceClick)="clear()" paftooltip="Effacer_la_saisie" btnDebounceClick>
                    <i class="fas fa-eraser"></i>
                </button>
                <button *ngIf="canSetAsReferent" class="btn btn-xs btn-secondary ml-1" (debounceClick)="setAsReferent()" paftooltip="Definir_comme_referent" btnDebounceClick>
                    <i class="fas fa-user-shield"></i>
                </button>
            </div>
        </div>
    </div>
</form>